<template lang="pug">
  .type-writer(:class="color")
    .input
      input(
        :class="[redClass, fontWeight]"
        ref="input"
        type="text"
        placeholder="make history."
        onfocus="this.placeholder = ''"
        onblur="this.placeholder = 'make history.'"
      )
    .config
      .weight
        button.f-0(@click="handleWeight('n')") r
        button.f-0(@click="handleWeight('b')") b
        button.f-0(@click="handleWeight('i')") i
      .bitmap
        vue-slide-bar.slider(
          v-model="sliderVal"
          :processStyle="{ backgroundColor: '#000' }"
          :min="0"
          :max="99"
          :line-height="2"
        )
          template(slot="tooltip" slot-scope="tooltip")
            .circle
      </template>
</template>

<script>
import VueSlideBar from 'vue-slide-bar'

export default {
  name: "FontWriter",

  components: {
    VueSlideBar
  },

  data() {
    return {
      displayText: "make history.",
      sliderVal: 0,
      redClass: "f-0",
      fontWeight: "n",
      marks: ["f-0", "f-1", "f-2", "f-3", "f-4", "f-5", "f-6"]
    };
  },

  props: ["color"],

  methods: {
    handleWeight(s) {
      this.fontWeight = s;
    }
  },

  mounted() {
    // this.$refs.input.focus()
  },

  watch: {
    sliderVal() {
      const val = this.sliderVal / 100;
      const index = Math.floor(val * 7);
      this.redClass = this.marks[index];
    }
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-writer
  height: auto
  width: 100vw
  position: relative
  user-select: none
  @media only screen and (min-width: $m)
    height: 100vH
  .input
    width: 95vw
    margin: 10rem auto 0 auto
    border: none
    height: auto
    @media only screen and (min-width: $m)
      height: 45.4rem
      width: 88.19vw
      margin: 21rem auto 0 auto
    input
      width: calc(100% - 5rem)
      height: 100%
      border: none
      padding: 0
      font-size: 12.5vw
      line-height: 1
      padding-left: 3rem
      cursor: none !important
      &:focus
        outline: none
      &::placeholder
        text-align: center
  .config
    width: 76.38888889vw
    margin: 7rem auto 7rem auto
    display: flex
    justify-content: space-between
    flex-direction: column
    @media only screen and (min-width: $m)
      flex-direction: row
      width: 76.38888889vw
      margin: 3.5rem auto 3.5rem auto
    .weight
      width: 100%
      display: flex
      justify-content: center
      @media only screen and (min-width: $m)
        width: unset
        display: block
    button
      border: none
      font-size: 2.5rem
      line-height: 2.7rem
      background: none
      color: #000
      width: 3.1rem
      height: 3.1rem
      border: 2px solid #000
      border-radius: 50%
      margin: 0 .925rem
      cursor: none !important
      padding: 0
      @media only screen and (min-width: $m)
        width: 6.2rem
        height: 6.2rem
        border: 4px solid #000
        font-size: 4.8rem
        line-height: 5.76rem
        margin-left: 1.85rem
      &:focus
        outline: none
    .bitmap
      width: 100%
      display: flex
      align-items: center
      height: 5.4rem
      margin-top: 2.5rem
      @media only screen and (min-width: $m)
        margin: 0
        width: 65%
      .slider
        width: 100% !important
        padding: 0 !important
        transform: translateY(-.1rem)
        .vue-slide-bar
          background-color: #000
        .circle
          border: solid 2px #000
          border-radius: 50%
          width: 2.7rem
          height: 2.7rem
          background-color: #FFF
          cursor: none !important
          transform: translateY(1.2rem)
          @media only screen and (min-width: $m)
            width: 5.4rem
            height: 5.4rem
            border: solid 4px #000
            transform: translateY(0)
</style>
